export default __webpack_public_path__ + "assets/logo-trans.c8c5a29d.png";